import React from "react";
import "./styles/BusinessInfo.scss";
import BtnViewMore from "../../components/BtnViewMore";
import { useTranslation } from "react-i18next";
import { useLangNavigate } from "../../hooks/useLangNavigate";
const BusinessInfo = () => {
  const { t } = useTranslation();
  const langNavigate = useLangNavigate();
  const handleBtn = (e: any) => {
    const { to, tap } = contents[Number(e.currentTarget.id)];
    langNavigate(to, { state: { tap } });
  };
  const contents = [
    {
      to: "/digital-transformation",
      tap: 1,
      path: "/imgs/bg_home_business_info_04.png",
      id: "dt",
    },

    {
      to: "/esg-rnd",
      tap: 0,
      path: "/imgs/bg_home_business_info_02.png",
      id: "rnd",
    },
    {
      to: "/design",
      tap: 1,
      path: "/imgs/bg_home_business_info_03.png",
      id: "design",
    },
    {
      to: "/eco-planning",
      tap: 0,
      path: "/imgs/bg_home_business_info_01.png",
      id: "consulting",
    },
  ];
  return (
    <>
      <div id="business_info_wrap">
        <div className="title_wrap">
          <h2 className="title">{t("home.business.title")}</h2>
        </div>
        <div className="card_wrap">
          {contents.map((content: { path: string; id: string }, index: number) => {
            return (
              <div id={String(index)} className="card" key={`${content.path}_${index}`}>
                <div className="left">
                  <div className="img_box">
                    <img src={content.path} alt={content.id} />
                  </div>
                </div>
                <div className="right">
                  <h2 className="name">{t(`home.business.content.${content.id}.name`)}</h2>
                  <div className="des">{t(`home.business.content.${content.id}.des`)}</div>
                  <BtnViewMore id={String(index)} onClick={handleBtn} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default BusinessInfo;
